/**
 * Finders that keep the product image on a completed chapter tile but drop the chapter headline
 * over it (KON-2109). Finder ids repeat across environments and tenants, so match the pair.
 */
const FINDERS_WITHOUT_HEADLINE_ON_IMAGE = [
  // Volksbank im Rheinland, Firmenkunden (prod)
  { finderId: 11000, tenantId: 967720 },
  // Pre-prod finders the client tests the change on
  { finderId: 12816, tenantId: 260290 },
  { finderId: 11499, tenantId: 260290 },
];

export function isHeadlineOnImageHidden(pagesFlow) {
  const finderId = pagesFlow?.finder?.id;
  const tenantId = pagesFlow?.tenant?.id;

  return FINDERS_WITHOUT_HEADLINE_ON_IMAGE.some(item => item.finderId === finderId && item.tenantId === tenantId);
}
